import { useState } from "react";
import Modal from "@mui/material/Modal";
import { styled } from "@mui/material/styles";
import CloseIcon from "@mui/icons-material/Close";
import { IconButton } from "@mui/material";
import { Typography as T } from "@mui/material";
import SupervisorAccountOutlinedIcon from "@mui/icons-material/SupervisorAccountOutlined";
import { colors } from "../styles";
import Button from "./Button";
import { SectionFlexColumn, SectionFlexRow } from "./General";
import { TextInput } from "./General";
import useInviteNewTeamMember from "../hooks/mutations/admin/useInviteNewTeamMember";

const ModalContainer = styled("div")(`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  width: 500px;
  background-color: ${colors.white};
  border-radius: 5px;
  padding: 16px 32px;
`);

const H2 = styled("h2")(`
  font-size: 20px;
  margin: 0;
  margin-left: 8px;
`);

interface Props {
  modalStatus: boolean;
  closeModal: () => void;
  customDescription?: string;
}

const InviteNewAdminModal = ({
  modalStatus,
  closeModal,
  customDescription,
}: Props) => {
  const [email, setEmail] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const { mutate: inviteTeamMember, status } = useInviteNewTeamMember({
    onSuccessHandler: () => {
      setEmail("");
      setFirstName("");
      setLastName("");
      closeModal();
    },
  });

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    inviteTeamMember({ email, first_name: firstName, last_name: lastName });
  };

  return (
    <Modal
      open={modalStatus}
      onClose={closeModal}
      aria-labelledby="invite-new-admin-modal"
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <ModalContainer>
        <SectionFlexColumn style={{ display: "flex", alignItems: "start" }}>
          <SectionFlexRow style={{ marginTop: 20 }}>
            <SupervisorAccountOutlinedIcon />
            <H2>Invite Admin</H2>
            <IconButton onClick={closeModal} style={{ marginLeft: "auto" }}>
              <CloseIcon />
            </IconButton>
          </SectionFlexRow>
        </SectionFlexColumn>
        {status === "loading" ? (
          <T>Submitting...</T>
        ) : (
          <form onSubmit={handleSubmit}>
            <TextInput
              size="small"
              placeholder="Their work email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <TextInput
              size="small"
              placeholder="Their first name"
              required
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
            />
            <TextInput
              size="small"
              placeholder="Their last name"
              required
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
            />
            <Button type="submit" style={{ marginTop: 16 }}>
              Invite
            </Button>
          </form>
        )}
      </ModalContainer>
    </Modal>
  );
};

export default InviteNewAdminModal;
